import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonMenuButton,
  IonText,
  IonContent,
} from "@ionic/react";
import { Business } from "@mui/icons-material";
import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import styles from "./GenerateInviteCode.module.css";
import { useBusinessContext } from "../../context/business-context";
import GenerateCodeModal from "../../components/generate-code-modal";
import GenerateCodeTable from "../../components/generate-code-table";
import {
  Modal,
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Grid,
  Skeleton,
} from "@mui/material";
import axios from "axios";
import { requestID, baseUrl, config } from "../../common/utils";
import { configDefaults } from "vitest/dist/config";

const GenerateInviteCode = () => {
  const history = useHistory();
  const { selectedBusinessId ,selectedBusinessName} = useBusinessContext();
  const [status, setStatus] = useState({ loading: false, error: false });
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertMsg, setAlertMsg] = useState<string>("");
  const [branches, setBranches] = useState([]);
  const [roles, setRoles] = useState([]);
  const [activatationList, setActivatationList] = useState([]);
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const getBranches = async () => {
    // try {
    setStatus({ loading: true, error: false });

    const formData = new FormData();
    formData.append("requestID", requestID());
    formData.append("business_id", selectedBusinessId);

    console.log(formData);

    const response = await axios.post(
      baseUrl() + "businesss/getMyActivationCodeList",
      formData,
      config
    );
    console.log({ response });

    const data = await response.data.data;
    console.log(data);
    setBranches(data[2]);
    setRoles(data[1]);
    setActivatationList(data[0]);
    setStatus({ loading: false, error: false });
    // } catch (error) {
    console.error();
    //   setAlertMsg(error.response.data.message);
    onShowAlert();
    // }
  };

  const getRoles = async () => {
    // try {
    setStatus({ loading: true, error: false });
    const formData = new FormData();
    formData.append("requestID", requestID());
    console.log(formData);
    const response = await axios.post(
      baseUrl() + "settings/getRoles",
      formData,
      config
    );
    console.log({ response });
    const data = await response.data.data;
    console.log(data);
    setRoles(data);
    setStatus({ loading: false, error: false });
    // } catch (error) {
    console.error();
    //   setAlertMsg(error.response.data.message);
    onShowAlert();
    // }
  };

  const onShowAlert = () => {
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 5000);
  };

  useEffect(() => {
    getBranches();
    // getRoles();
  }, []);

  return (
    <IonPage className="ion-padding">
      <IonHeader>
        <Box display="flex" justifyContent="space-between" p={2}>
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Typography variant="h6" sx={{ color: "chocolate", flex: 1 }}>
              {/* <Business className={styles.titleIcon} /> */}
              {selectedBusinessName.toUpperCase()} -  Generate Invite Code
            </Typography>
          </motion.div>

          <Box>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setIsModalOpen(true);
              }}
            >
              Generate Code
            </Button>

            <Button
              variant="outlined"
              color="secondary"
              onClick={() => history.goBack()}
              style={{ marginLeft: 10 }}
            >
              Go Back
            </Button>
          </Box>
        </Box>
      </IonHeader>

      <IonContent fullscreen className={styles.container}>
        {/* <Box className={styles.header}>
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Typography variant="h4" component="h1" className={styles.title}>
              <Business className={styles.titleIcon} />
              Generate Code
            </Typography>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
          >
          
          </motion.div>
        </Box> */}

        {!status.loading ? (
          <GenerateCodeTable rows={activatationList} />
        ) : (
          <Grid container spacing={1}>
            {[1, 2, 3, 4, 5, 6].map((item) => (
              <Grid item xs={12} sm={12} md={12} key={item}>
                <Card className={styles.skeletonCard}>
                  <CardContent>
                    <Skeleton variant="rectangular" height={30} width="100%" />
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}

        <GenerateCodeModal
          branches={branches}
          roles={roles}
          isOpen={isModalOpen}
          onClose={
            () => setIsModalOpen(false)}
            onGetactivationList={()=>getBranches()}
          
        />
      </IonContent>
    </IonPage>
  );
};

export default GenerateInviteCode;
